import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Divider, Form, Input, InputNumber, message } from "antd";
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const InsAqiForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props

    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            // 安全地将可能为字符串的数值转换为 Number，
            // 对于 null / undefined / 空字符串 返回 undefined，保证 0 能正确保留
            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                // angleX: parseNumber(data.angleX),
                // angleY: parseNumber(data.angleY),
                // angleZ: parseNumber(data.angleZ),
                // accX: parseNumber(data.accX),
                // accY: parseNumber(data.accY),
                // accZ: parseNumber(data.accZ),
                // angularVelocityX: parseNumber(data.angularVelocityX),
                // angularVelocityY: parseNumber(data.angularVelocityY),
                // angularVelocityZ: parseNumber(data.angularVelocityZ),
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            const res = await editDeviceCalibrateResultRequest(params, sn);
            
            if (res.data.code === 0) {
                message.success('下发组合惯导标定结果成功');
                // 提交成功后通知所有表单刷新
                onRefreshAll?.();
            } else {
                message.error('下发组合惯导标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发组合惯导标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>组合惯导标定结果</Divider>
        <Form form={form} labelAlign="left" labelCol={{ span: 6, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 14 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '20px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="标定状态" name="success" style={{ marginBottom: '20px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            {/* <Form.Item label="角度X" name="angleX">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="角度Y" name="angleY">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="角度Z" name="angleZ">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="加速度X" name="accX">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="加速度Y" name="accY">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="加速度Z" name="accZ">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="角速度X" name="angularVelocityX">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="角速度Y" name="angularVelocityY">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="角速度Z" name="angularVelocityZ">
               <InputNumber style={{ width: '100%' }} />
            </Form.Item> */}
            <div style={{ textAlign: 'right' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发组合惯导标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default InsAqiForm;